import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import { DropDownMenu, MenuItem } from 'material-ui';


import '../../../../../grid.css';
import './BreakDownTile.css';
import { formattedNumber } from '../../../../../utils/formatterHelpers';

class BreakDownTile extends React.Component {
    static propTypes = {
        annualResults: PropTypes.object.isRequired,
        taxEntity: PropTypes.bool.isRequired,
        selectedFinancing: PropTypes.number.isRequired,
        projectState: PropTypes.number.isRequired,
        sgipToggle: PropTypes.bool.isRequired,
        includeESS: PropTypes.bool.isRequired,
        resiToggle: PropTypes.bool.isRequired,
        isLocked: PropTypes.bool.isRequired,
        doughnutSlider: PropTypes.number.isRequired,
        cashprice: PropTypes.number.isRequired,
        loanTerm: PropTypes.number.isRequired,
        ppaTerm: PropTypes.number.isRequired,
        obsTerm: PropTypes.number.isRequired,
        systemSize: PropTypes.number.isRequired,
        capTerm: PropTypes.number.isRequired,
        mosaicTerm: PropTypes.number.isRequired,
        loanProvider: PropTypes.string.isRequired,
        setMosaicTerm: PropTypes.func.isRequired,
        downPayment: PropTypes.number.isRequired,
        mosaicDownPayment: PropTypes.number.isRequired,
        obsDownPayment: PropTypes.number.isRequired,
        capDownPayment: PropTypes.number.isRequired,
    };

    handleMosaicTermChange(value) {
        const { setMosaicTerm } = this.props;
        setMosaicTerm(value);
    }


    render() {
        const {
            annualResults,
            taxEntity,
            selectedFinancing,
            projectState,
            sgipToggle,
            includeESS,
            doughnutSlider,
            cashprice,
            loanTerm,
            ppaTerm,
            obsTerm,
            resiToggle,
            systemSize,
            capTerm,
            loanProvider,
            mosaicTerm,
            isLocked,
            downPayment,
            mosaicDownPayment,
            obsDownPayment,
            capDownPayment,
        } = this.props;

        const doughYears = doughnutSlider;
        let smartYears = 10;
        if (systemSize / 1000 > 25) {
            smartYears = 20;
        }

        let cumulativeSavingsALL = 0;
        if (selectedFinancing === 1) {
            cumulativeSavingsALL =
            formattedNumber(annualResults[doughYears].cumulativePPASavings);
        } else if (selectedFinancing === 2 && loanProvider === 'mosaic') {
            cumulativeSavingsALL =
            formattedNumber(annualResults[doughYears].cumulativeMosaicSavings);
        } else if (selectedFinancing === 2 && loanProvider === 'custom') {
            cumulativeSavingsALL =
            formattedNumber(annualResults[doughYears].cumulativeLoanSavings);
        } else if (selectedFinancing === 3) {
            cumulativeSavingsALL =
            formattedNumber(annualResults[doughYears].cumulativeOBSSavings);
        } else if (selectedFinancing === 4) {
            cumulativeSavingsALL =
            formattedNumber(annualResults[doughYears].cumulativeCashSavings);
        } else if (selectedFinancing === 5) {
            cumulativeSavingsALL =
            formattedNumber(annualResults[doughYears].cumulativeCAPSavings);
        }

        let annualSavingsALL = 0;
        if (selectedFinancing === 1) {
            annualSavingsALL = formattedNumber(annualResults[doughYears].annualPPASavings);
        } else if (selectedFinancing === 2 && loanProvider === 'mosaic') {
            annualSavingsALL = formattedNumber(annualResults[doughYears].annualMosaicSavings);
        } else if (selectedFinancing === 2 && loanProvider === 'custom') {
            annualSavingsALL = formattedNumber(annualResults[doughYears].annualLoanSavings);
        } else if (selectedFinancing === 3) {
            annualSavingsALL = formattedNumber(annualResults[doughYears].annualOBSSavings);
        } else if (selectedFinancing === 4) {
            annualSavingsALL = formattedNumber(annualResults[doughYears].annualCashSavings);
        } else if (selectedFinancing === 5) {
            annualSavingsALL = formattedNumber(annualResults[doughYears].annualCAPSavings);
        }

        let financeTerm = loanTerm;
        if (loanProvider === 'mosaic' && resiToggle) {
            financeTerm = mosaicTerm;
        }
        let finanacePayment = annualResults[doughYears]
            .loanPayment;
        if (loanProvider === 'mosaic' && resiToggle) {
            finanacePayment = annualResults[doughYears]
                .annualHomeLoanPayment;
        }

        let loanType = 'Loan';
        if (loanProvider === 'mosaic' && resiToggle) {
            loanType = 'Mosaic';
        }
        let deposit = 0;
        if (selectedFinancing === 2 && loanProvider === 'mosaic' && doughnutSlider === 1) {
            deposit = mosaicDownPayment;
        } else if (selectedFinancing === 2 && loanProvider === 'custom' && doughnutSlider === 1) {
            deposit = downPayment;
        } else if (selectedFinancing === 3 && doughnutSlider === 1) {
            deposit = obsDownPayment;
        } else if (selectedFinancing === 5 && doughnutSlider === 1) {
            deposit = capDownPayment;
        }

        const itc = annualResults[doughYears].itc;
        const cashITC = annualResults[doughYears].cashITC;

        return (
            <div>
                <Paper className="breakdownPaper" elevation={3}>
                    <div className="breakdownTile">
                        <h1>Year {doughnutSlider} Breakdown</h1>
                        <div className="col yearlyFigures">
                            <div className="col span-1-of-2breakdownTileL leftList">
                                <ul>
                                    {doughnutSlider === 1 &&
                                    taxEntity === true
                                    && selectedFinancing > 1
                                    && selectedFinancing !== 3 ? (
                                        <div>
                                                <li>ITC</li>
                                            </div>
                                        ) : null}
                                    {doughnutSlider === 1
                                            && taxEntity === true
                                            && resiToggle === false
                                            && selectedFinancing > 1
                                            && selectedFinancing !== 3
                                        ? (
                                            <div>
                                                <li>MACRS</li>
                                            </div>
                                        ) : null}
                                    {doughnutSlider === 1
                                            && taxEntity === true
                                            && resiToggle
                                            && projectState === 2
                                        ? (
                                            <div>
                                                <li>MA Tax Credit</li>
                                            </div>
                                        ) : null}
                                    {projectState === 2 && doughnutSlider <= smartYears ? (
                                        <div>
                                            <li>SMART</li>
                                        </div>
                                    ) : null }
                                    {doughnutSlider === 1 &&
                                            sgipToggle === true && includeESS === true &&
                                            projectState === 1 && selectedFinancing > 1 ? (
                                            <div>
                                                    <li>SGIP</li>
                                                </div>
                                        ) : null}
                                    {doughnutSlider < 6 &&
                                    sgipToggle === true && includeESS === true &&
                                    projectState === 1 && selectedFinancing > 1 ? (
                                        <div>
                                                <li>SGIP PBI</li>
                                            </div>
                                        ) : null}
                                    {projectState === 3 &&
                                    selectedFinancing > 1 && doughnutSlider <= 15 ? (
                                        <div>
                                                <li>RECs</li>
                                            </div>
                                        ) : null}
                                    {projectState === 4 &&
                                        doughnutSlider === 1 &&
                                    selectedFinancing > 1 ? (
                                        <div>
                                                <li>NY Rebate</li>
                                            </div>
                                        ) : null}
                                    { resiToggle && projectState === 4 &&
                                            doughnutSlider < 2 &&
                                        selectedFinancing > 1 ? (
                                            <div>
                                                <li>NY Tax Credit</li>
                                            </div>
                                        ) : null}
                                    {projectState === 4 &&
                                        doughnutSlider < 5 &&
                                    selectedFinancing > 1 ? (
                                        <div>
                                                <li>NYC Abatement</li>
                                            </div>
                                        ) : null}

                                    {projectState === 3 && selectedFinancing > 1 &&
                                    doughnutSlider > 15 ? (
                                        <div>
                                                <li>RECs</li>
                                            </div>
                                        ) : null}
                                    {selectedFinancing >= 1 ? (
                                        <div>
                                            <li>Elec. Savings</li>
                                        </div>
                                    ) : null}
                                    {deposit && doughnutSlider === 1 ? (
                                        <div>
                                            <li>Deposit</li>
                                        </div>
                                    ) : null}
                                    {selectedFinancing === 1 && doughnutSlider <= ppaTerm ? (
                                        <div>
                                            <li>PPA</li>
                                        </div>
                                    ) : null}
                                    {selectedFinancing === 2 &&
                                        doughnutSlider <= (financeTerm / 12) ? (
                                            <div>
                                                <li>{loanType}</li>
                                            </div>
                                        ) : null}
                                    {selectedFinancing === 3
                                    && doughnutSlider <= (obsTerm / 12) ? (
                                        <div>
                                                <li>Lease</li>
                                            </div>
                                        ) : null}
                                    {selectedFinancing === 5
                                    && doughnutSlider <= (capTerm / 12) ? (
                                        <div>
                                                <li>Cap. Lease</li>
                                            </div>
                                        ) : null}
                                    {selectedFinancing === 3
                                    && doughnutSlider === ((obsTerm + 12) / 12) ? (
                                        <div>
                                                <li>Lease Buyout</li>
                                            </div>
                                        ) : null}
                                    {selectedFinancing === 3
                                    && doughnutSlider === ((obsTerm + 12) / 12) ? (
                                        <div>
                                                <li>ITC on Buyout</li>
                                            </div>
                                        ) : null}
                                    {doughnutSlider === 1 &&
                                    selectedFinancing === 4 ? (
                                        <div>
                                                <li>Solar</li>
                                            </div>
                                        ) : null}
                                    <li>
                                        Net:
                                    </li>
                                </ul>
                            </div>
                            <ul>
                                <div className="col span-1-of-2breakdownTileR rightList">
                                    {doughnutSlider === 1
                                    && taxEntity === true
                                    && selectedFinancing === 2
                                        ? (
                                            <div>
                                                <li>
                                                    $ {formattedNumber(itc)}
                                                </li>
                                            </div>
                                        ) : null}
                                    {doughnutSlider === 1
                                    && taxEntity === true
                                    && selectedFinancing > 1
                                    && selectedFinancing !== 3
                                    && selectedFinancing !== 2
                                        ? (
                                            <div>
                                                <li>
                                                    $ {formattedNumber(cashITC)}
                                                </li>
                                            </div>
                                        ) : null}
                                    {doughnutSlider === 1 &&
                                    taxEntity === true
                                    && resiToggle === false
                                    && selectedFinancing > 1
                                    && selectedFinancing !== 3 ? (
                                        <div>
                                                <li>$ {formattedNumber(annualResults[doughYears]
                                                    .macrs)}
                                            </li>
                                            </div>
                                        ) : null}
                                    {doughnutSlider === 1 &&
                                    taxEntity === true
                                    && resiToggle
                                    && projectState === 2 ? (
                                        <div>
                                                <li>$ {formattedNumber(annualResults[doughYears]
                                                    .maStateTaxCredit)}
                                            </li>
                                            </div>
                                        ) : null}
                                    {projectState === 2 && doughnutSlider <= smartYears ? (
                                        <div>
                                            <li>$ {formattedNumber(annualResults[doughYears]
                                                .smart)}
                                            </li>
                                        </div>
                                    ) : null }{doughnutSlider === 1 &&
                                    sgipToggle === true && includeESS === true &&
                                    projectState === 1 && selectedFinancing > 1
                                        ? (
                                            <div>
                                                <li>$ {formattedNumber(annualResults[doughYears]
                                                    .sgip)}
                                                </li>
                                            </div>
                                        ) : null}
                                    {doughnutSlider < 6 && sgipToggle === true && includeESS === true &&
                                    projectState === 1 && selectedFinancing > 1 ? (
                                        <div>
                                                <li>$ {formattedNumber(annualResults[doughYears]
                                                    .sgipPBI)}
                                            </li>
                                            </div>
                                        ) : null}
                                    {projectState === 3 && selectedFinancing > 1 ? (
                                        <div>
                                            <li>$ {formattedNumber(annualResults[doughYears]
                                                .recs)}
                                            </li>
                                        </div>
                                    ) : null}
                                    {projectState === 4 && annualResults[doughYears]
                                        .nyserdaRebate ? (
                                            <div>
                                                <li>$ {formattedNumber(annualResults[doughYears]
                                                    .nyserdaRebate)}
                                                </li>
                                            </div>
                                        ) : null}
                                    {projectState === 4 && annualResults[doughYears]
                                        .nyResiTaxCredit ? (
                                            <div>
                                                <li>$ {formattedNumber(annualResults[doughYears]
                                                    .nyResiTaxCredit)}
                                                </li>
                                            </div>
                                        ) : null}
                                    {projectState === 4 && selectedFinancing === 2 && annualResults[doughYears]
                                        .mosaicNYAbatement ? (
                                            <div>
                                                <li>$ {formattedNumber(annualResults[doughYears]
                                                    .mosaicNYAbatement)}
                                                </li>
                                            </div>
                                        ) : null}
                                    {projectState === 4 &&
                                        selectedFinancing !== 2 && selectedFinancing > 1 ? (
                                            <div>
                                                <li>$ {formattedNumber(annualResults[doughYears]
                                                    .cashNYAbatement)}
                                                </li>
                                            </div>
                                        ) : null}
                                    {selectedFinancing >= 1 ? (
                                        <div>
                                            <li>$
                                                {formattedNumber(annualResults[doughYears]
                                                    .annualSolarSavings)}
                                            </li>
                                        </div>
                                    ) : null}
                                    {deposit ? (
                                        <div>
                                            <li>- $
                                                {formattedNumber(deposit)}
                                            </li>
                                        </div>
                                    ) : null}
                                    {selectedFinancing === 1 && doughnutSlider <= ppaTerm ? (
                                        <div>
                                            <li>- $ {formattedNumber(annualResults[doughYears]
                                                .ppaBill)}
                                            </li>
                                        </div>
                                    ) : null}
                                    {selectedFinancing === 2
                                        && doughnutSlider <= (financeTerm / 12) ? (
                                            <div>
                                                <li>- $ {formattedNumber(finanacePayment)}
                                                </li>
                                            </div>
                                        ) : null}
                                    {selectedFinancing === 3
                                    && doughnutSlider <= ((obsTerm + 12) / 12) ? (
                                        <div>
                                                <li>
                                                - $ {formattedNumber(annualResults[doughYears]
                                                        .annualOBSPayment)}
                                            </li>
                                            </div>
                                        ) : null}
                                    {selectedFinancing === 5
                                    && doughnutSlider <= (capTerm / 12) ? (
                                        <div>
                                                <li>
                                                - $ {formattedNumber(annualResults[doughYears]
                                                        .annualCAPPayment)}
                                            </li>
                                            </div>
                                        ) : null}
                                    {selectedFinancing === 3
                                    && doughnutSlider === ((obsTerm + 12) / 12) ? (
                                        <div>
                                                <li>$ {formattedNumber(annualResults[doughYears]
                                                    .obsITC)}
                                            </li>
                                            </div>
                                        ) : null}
                                    {doughnutSlider === 1 && selectedFinancing === 4 ? (
                                        <div>
                                            <li>- $ {formattedNumber(cashprice)}
                                            </li>
                                        </div>
                                    ) : null}
                                    <li className="lastLine">$ {annualSavingsALL}</li>
                                </div>
                            </ul>
                        </div>
                        <div className="clearfixclass" />
                        {doughnutSlider > ppaTerm && selectedFinancing === 1 ? (
                            <div className="row cumSavings">
                                <h2 className="SavingsTitle">Cumulative savings:</h2>
                                <p className="SavNumber">$ {cumulativeSavingsALL}</p>
                                <p className="assumingText">(Assuming $1.00 buyout)</p>
                            </div>
                        ) : (
                            <div className="row cumSavings">
                                {selectedFinancing === 4 && doughYears === 1 ? (
                                    <div>
                                        <h2 className="SavingsTitle">Net out of Pocket year {doughnutSlider}:</h2>
                                        <p className="SavNumber">$ {cumulativeSavingsALL}</p>
                                    </div>
                                ) :
                                    <div>
                                        <h2 className="SavingsTitle">Cumulative savings in Y{doughnutSlider}</h2>
                                        <p className="SavNumber">$ {cumulativeSavingsALL}</p>
                                    </div>
                                }
                            </div>)
                        }
                    </div>
                </Paper>
                {loanProvider === 'mosaic' && selectedFinancing === 2 ? (
                    <div>
                        <h4>
                            Choose Your Mosaic Option
                        </h4>
                        <div className="row">
                            <DropDownMenu
                                fullWidth
                                label="Mosaic Term"
                                value={mosaicTerm}
                                onChange={(e, index, value) =>
                                    this.handleMosaicTermChange(value)}
                                disabled={isLocked}
                            >
                                <MenuItem value={120} primaryText="Mosaic 10 Year / 3.99%" />
                                <MenuItem value={180} primaryText="Mosaic 15 Year / 4.99%" />
                                <MenuItem value={240} primaryText="Mosaic 20 Year / 5.49%" />
                            </DropDownMenu>
                        </div>
                    </div>
                ) : null }
            </div>
        );
    }
}

export default BreakDownTile;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/BreakDownTile/BreakDownTile.js